
import {urls} from "../../constants";
import { axiosService } from "../axios.service";


const productBrandService = {
    getAll: () => axiosService.get(urls.settings.productBrands).then(value => value.data),
    createBrand: (data) => axiosService.post(urls.settings.productBrands, data).then((value) => value.data),
    updateById: (id, data) => axiosService.patch(`${urls.settings.productBrands}/${id}`, data).then((value) => value.data),
    deleteById: (id) => axiosService.destroy(`${urls.settings.productBrands}/${id}`),
};

export {
    productBrandService
}
